import React from 'react';
import { Button, Tooltip, Icon, Popover, } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';

import { SvgIconText } from "freesia-ui";
import brace from 'brace';
import AceEditor from 'react-ace';
import PropertyEditor from "../PropertyEditor";
import "brace/ext/language_tools";

import "brace/mode/css";
import "brace/mode/json";
import "brace/mode/html";
import "brace/mode/javascript";
import "brace/snippets/css";
import "brace/snippets/json";
import "brace/snippets/html";
import "brace/snippets/javascript";
import "brace/theme/chrome";
import jsJson from "./datascreen-js-lang.json";
import _ from 'lodash';

import ObservablePropertyDescriptorObject from '../../designer/utils/ObservablePropertyDescriptorObject';

// let lt = brace.acequire('ace/ext/language_tools');

let langJsonCache = {};
let codeAssistCache = {};

export default class CodeEditor extends PropertyEditor {

    constructor(props, context) {
        super(props, context);
        this.state = {
            width: 150,
            id: `ace-${Math.random()}`,
            showLargeCode: false,
            value: this.props.source.value || ''
        }

        // lt.setCompleters([lt.snippetCompleter, lt.textCompleter, lt.keyWordCompleter, {
        //     identifierRegexps: [/[a-zA-Z_0-9\.\$\-\u00A2-\uFFFF]/],
        //     getDocTooltip: (item) => {
        //         let caption = item.caption || '';
        //         if (caption.indexOf('model') > -1) {
        //             let model = this.props.propertyGrid.props.source || {};
        //             let detail = this.getDetailFromAllKey(model, item.caption);

        //             // let model = this.props.propertyGrid.props.source || {};
        //             // let detail = this.getDetailFromModel(model);
        //             if (!item.docHTML && detail.alias) {
        //                 item.docHTML = [
        //                     "<b>", detail.alias, "</b>", "<hr></hr>",
        //                     this.splitDocHtml(detail.description || item.name)
        //                 ].join("");
        //             }
        //         }
        //     },
        //     getCompletions: (editor, session, pos, prefix, callback) => {

        //         let mode = editor.getOption('mode');
        //         // var wordScore = wordDistance(session, pos, prefix);
        //         // var wordList = Object.keys(wordScore);
        //         let langJson = [];
        //         if (mode.indexOf('javascript') > -1) {
        //             langJson = [...jsJson];
        //             let model = {
        //                 getType: () => {
        //                     return '__base'
        //                 }
        //             };
        //             try {
        //                 model = this.props.propertyGrid.props.source;
        //             } catch (e) {

        //             }
        //             let modeType = model.getType ? model.getType() : model.constructor.name;
        //             if (langJsonCache[modeType]) {
        //                 langJson = langJsonCache[modeType];
        //             } else {
        //                 let _args = model._args || {};
        //                 // if (prefix.indexOf('model') > -1 && prefix.indexOf('.') > -1) {
        //                 // }

        //                 langJson.forEach(item => {
        //                     if (item.attrs) {
        //                         langJson = [...item.attrs.map(attr => {
        //                             return {
        //                                 name: item.name + '.' + attr.name,
        //                                 value: item.value + '.' + attr.value,
        //                                 snippet: item.value + '.' + attr.snippet
        //                             }
        //                         }), ...langJson];
        //                     }
        //                 })

        //                 let codeAssists = [];
        //                 if (model.codeAssist) {
        //                     let [settings, codeAssistJson] = model.codeAssist() || [{}, {}];
        //                     Object.keys(codeAssistJson).forEach(key => {
        //                         if (!codeAssistCache[key]) {
        //                             codeAssistCache[key] = this.generateLangJson(key, codeAssistJson[key], false, settings.level);
        //                         }
        //                         codeAssists = [...codeAssists, ...codeAssistCache[key]]
        //                     })
        //                 }

        //                 langJson = [
        //                     ...langJson,
        //                     ...this.generateLangJson('model', model),
        //                     ...this.generateLangJson('this', _args),
        //                     ...codeAssists
        //                 ];
        //                 langJsonCache[modeType] = langJson;
        //             }
        //         }

        //         callback(null, langJson.map(data => {
        //             return {
        //                 name: data.name,
        //                 value: data.value,
        //                 caption: data.caption || data.value,
        //                 meta: data.meta || "datascreen-script",// data.meta || data.value,
        //                 snippet: data.snippet || '',
        //                 // type: "snippet",
        //                 score: data.score || 1000 // 让test排在最上面
        //             }
        //         }));
        //     }
        // }]);
    }

    splitDocHtml(html) {
        var bytesCount = html.length;//0,;
        // for (let i = 0, n = html.length; i < n; i++) {
        //     let c = html.charCodeAt(i);
        //     if ((c >= 0x0001 && c <= 0x007e) || (0xff60 <= c && c <= 0xff9f)) {
        //         bytesCount += 1;
        //     } else {
        //         bytesCount += 2;
        //     }
        // }
        if (bytesCount > 16) {
            let list = [];

            let index = 0;
            while (index < bytesCount) {
                list.push(html.slice(index, index += 16));
            }
            return _.compact(list).join('<br/>');
        }
        return html;
    }
    getDetailFromAllKey(model, allKey) {
        let keys = allKey.replace(/\[n\]/g, '').split('.');
        let data = model;
        if (keys[0] !== 'model') {
            if (model.modelTemplate) {
                data = new model.modelTemplate();
            } else {
                data = model.value;
            }
        }
        keys.shift();
        if (keys.length === 1) {
            return this.getDetailFromModel(data, keys[0]);
        } else if (keys.length === 0) {
            return {};
        }
        // keys.shift();
        return this.getDetailFromAllKey(this.getDetailFromModel(data, keys[0]), keys.join('.'));

    }
    getDetailFromModel(model, key) {
        return model ? ((model._ || {})[key] || {}) : {};
    }
    generateLangJson(prefix, model, result, level) {
        if (!result) {
            result = [];
        }
        let func = (data, isCon) => {
            Object.getOwnPropertyNames(data).forEach(key => {
                if (key.startsWith('_') || key.endsWith('_')) {
                    return;
                }
                try {
                    let dataByKey = data[key];
                } catch (e) {
                    return;
                }
                let value = prefix + '.' + key;
                let dotLength = value.split('.').length;
                result.push({
                    name: value,
                    value: value,
                    snippet: value,
                    meta: this.getDetailFromModel(data, key).alias || "datascreen-script",
                    score: parseInt(1000 / dotLength)
                })
                if (isCon && dotLength < (level || 5)) {
                    if (data[key] instanceof ObservablePropertyDescriptorObject) {
                        this.generateLangJson(value, data[key], result);
                    } else if (data[key] instanceof Array) {
                        let attrs = Object.getOwnPropertyNames(Array.prototype);
                        attrs.forEach(attr => {
                            let arrayAttr = value + '.' + attr;
                            result.push({
                                name: arrayAttr,
                                value: arrayAttr,
                                snippet: arrayAttr,
                                meta: "array",
                                score: 1
                            })
                        });
                        let detail = this.getDetailFromModel(data, key);
                        if (detail && detail.modelTemplate) {
                            let subModel = new detail.modelTemplate();
                            this.generateLangJson(value + '[n]', subModel, result, level);
                        }
                    } else if (data[key] && (typeof (data[key]) === 'object' || typeof (data[key]) === 'function')) {
                        this.generateLangJson(value, data[key], result, level);
                    }
                }
            });
        }
        func(model, true);
        func(model.__proto__);
        return result;
    }

    onChange(value) {
        // this.value = value;
        // this.props.source.value = value;
        this.setState({
            value
        });
    }

    onBlur() {
        this.props.source.value = this.state.value;
    }

    onPropertyValueChanged(name, valOld, valNew, subName) {
        if (name === 'script' && valOld !== valNew && subName === undefined) {
            this.setState({
                value: valNew
            });
        }
    }

    componentDidMount() {


        this.unregisterResizeHandler = this.props.propertyGrid.registerResizeHandler(() => this.resize());

        setTimeout(() => {
            this.resize();
        }, 100);

        if (this.format) {
            this.handler = (e) => {
                if (e.altKey && e.shiftKey && e.keyCode === 70) {
                    this.format();
                }
            }
            let node = document.getElementById(this.state.id + '-editor');
            node && node.addEventListener('keydown', this.handler);
        }
    }

    componentWillReceiveProps(nextProps) {
        super.componentWillReceiveProps(nextProps);

    }

    componentWillUnmount() {

        super.componentWillUnmount();
        if (this.unregisterResizeHandler)
            this.unregisterResizeHandler();

        let node = document.getElementById(this.state.id + '-editor');
        node && this.handler && node.removeEventListener('keydown', this.handler);
    }

    onBeforeLoad(ace) {
        let editor = this.currentEditor = ace.edit(this.state.id + '-editor');
        editor && editor.getSession().setUseWorker(false);

    }

    setDiv(ref) {
        if (ref)
            this.div = ref;
    }

    resize() {

        if (!this.div)
            return;

        // this.setState({ width: (this.div.clientWidth - 1) || 150 });

        setTimeout(() => {
            this.setState({ width: (this.div.clientWidth - 1) || 150 });
        }, 1);
    }

    render() {
        if (this.div)
            this.state.width = (this.div.clientWidth - 2) || 150;

        let errorMsg = this.props.source.errorMsg;
        let editorProps = {
            height: "200px",
            width: `${this.state.width}px`
        }
        let { showLargeCode } = this.state;
        let bigCodeStyle = {}
        if (showLargeCode) {
            let width = `${this.state.width + 60}px`;
            bigCodeStyle = this.props.source.mode === "fullScreen" ?
                {
                    width: '100%',
                    height: '100%',
                    // border: "1px solid #ddd",
                    position: "fixed",
                    background: "rgb(245 245 245)",
                    top: 0,
                    bottom: 0,
                    left: 0,
                    right: 0,
                    zIndex: 1001
                } :
                {
                    width: width,
                    /* height: 100px; */
                    // border: "1px solid #ddd",
                    position: "fixed",
                    top: "70px",
                    // background: "rgb(245 245 245)",
                    bottom: -1,
                    /* left: 0; */
                    right: 0,
                    zIndex: 1001
                }
            editorProps = this.props.source.mode === "fullScreen" ?
                {
                    height: "100%",
                    width: window.innerWidth,
                } :
                {
                    height: "100%",
                    width: width,
                }
        }

        let aceEditor = <AceEditor
            mode={this.mode}
            theme="chrome"
            enableBasicAutocompletion={true}
            enableSnippets={true}
            enableLiveAutocompletion={true}
            showGutter={true}
            value={this.state.value}
            onBlur={this.onBlur.bind(this)}
            onChange={this.onChange.bind(this)}
            onBeforeLoad={this.onBeforeLoad.bind(this)}
            name={this.state.id + '-editor'}
            wrapEnabled={false}
            {...editorProps}
        />;
        return (
            <div key="1" ref={ref => this.setDiv(ref)} id={this.state.id} className="csseditor" style={{
                lineHeight: 'normal',
                position: 'relative'
            }}>
                <div className="layout-v" style={bigCodeStyle}>
                    <div className="layout-h center code-toolbar" style={{ paddingRight: showLargeCode ? 5 : 0 }}>
                        <div className="fill"></div>
                        {this.format &&
                            <Button
                                title={"格式化 Alt+Shift+F"}
                                className='btn-bd-hover btn-pd-sm'
                                onClick={() => this.format()}>
                                <SvgIconText type={'#anticon-tsconfigjson'} />
                            </Button>
                        }
                        <Button
                            title={showLargeCode ? "还原" : "最大化"}
                            className='btn-bd-hover btn-pd-sm'
                            onClick={() => this.setState({ showLargeCode: !showLargeCode })}>
                            <SvgIconText type={showLargeCode ? "#anticon-zoomout" : "#anticon-zoomin"} />
                        </Button>
                    </div>
                    <div className="code-editor fill h0">
                        {aceEditor}
                        {errorMsg && <Popover placement="topRight" title={"错误提示"} content={<div>{errorMsg}</div>} trigger="click">
                            <div style={{
                                position: "absolute",
                                right: 0,
                                bottom: 0,
                                color: '#f00'
                            }}>
                                <ExclamationCircleOutlined type="exclamation-circle" />
                            </div>
                        </Popover>}
                    </div>


                </div>

                {/* <textarea id={`textarea-${this.props.source.id}`} style={{ height: 50 }}></textarea> */}
            </div>
        );
    }
}
